import { Component, input, output, inject } from '@angular/core';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { Paginator } from "@shared/components/paginator/paginator";
import { PaginatorState } from 'primeng/paginator';
import { EmissionsFactory } from '@features/emissions/models/emissions-factory.model';
import { SortHeader } from "@shared/components/sort-header/sort-header";
import { FlagImage } from '@shared/components/flag-image/flag-image';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-emissions-factors-list',
  imports: [
    CommonModule,
    TableModule,
    Paginator,
    SortHeader,
    FlagImage
  ],
  templateUrl: './emissions-factors-list.html',
  styleUrl: './emissions-factors-list.scss',
})
export class EmissionsFactorsList {

  first = input<number>();
  rows = input<number>();
  data = input<EmissionsFactory[]>([]);
  factorMap = input<Record<string, string>>({});
  variationMap = input<Record<string, string>>({});
  totalRecords = input<number>(0);
  loading = input<boolean>(false);

  pageChange = output<PaginatorState>();

  sortBy = input<string | null>();
  sortOrder = input<string | null>();
  toggleSort = output<string>();


  getFactorName(code: string | null | undefined): string {
    if (!code) return '';
    return this.factorMap()[code] ?? code; // fallback si no existe
  }

  getVariationName(variation: string | null | undefined): string {
    if (!variation) return '';
    return this.variationMap()[variation] ?? variation;
  }

  handleToggleSort(columnName: string) {
    this.toggleSort.emit(columnName);
  }

  getGasValue(gases: { Name: string; Value: number | null }[], gasName: string): string {
    const gas = gases?.find(g => g.Name === gasName);
    return gas?.Value != null ? gas.Value.toFixed(3) : '(vacío)';
  }

  isWorldLocation(country: string): boolean {
    return country.toUpperCase() === 'WORLD' || country.toUpperCase() === 'WW';
  }

}
